module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Regular.7085458.otf";